import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ErrorService } from 'src/app/services/error.service';
import { FileService } from 'src/app/services/file.service';
import { ModalService } from 'src/app/services/modal.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { TrackParcelService } from 'src/app/services/track-parcel.service';
import { DateTimeService } from '../../services/date-time.service';
import { UserService } from '../../services/user.service';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
	templateUrl: './track-parcel-details-modal.html',
	selector: 'app-track-parcel-details-modal',
	styleUrls: ['./track-parcel-details-modal.scss'],
	animations: [
		trigger('detailExpand', [
			state('void', style({height: '0px', minHeight: '0', visibility: 'hidden'})),
			state('*', style({height: '*', visibility: 'visible'})),
			transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
		])
	]
})
export class TrackParcelDetailsModalComponent implements OnInit, OnDestroy {
	public dateTimeFormat: any;
	public id: any;
	public objectUrl: any = '';
	public podAttachments: any[];
	public regularAttachments: any[];
	public selectedCustomer: any;
	public parcelDetail;
	public user;
	public userSubscription: any;

	constructor(private _userService: UserService,
				private _dateTimeService: DateTimeService,
				private _modalService: ModalService,
				public dialogRef: MatDialogRef<TrackParcelDetailsModalComponent>,
				private _snackbarService: SnackbarService,
				private _errorService: ErrorService,
				private trackParcelService: TrackParcelService,
				private _spinnerService: SpinnerService,
				private _fileService: FileService,
				@Inject(MAT_DIALOG_DATA) public data: any) {
	}

	constructAssignments(element) {
		return [ { items: element?.assignmentItems } ];
	}

	ngOnDestroy() {
		if (this.userSubscription) {
			this.userSubscription.unsubscribe();
		}
	}

	ngOnInit() {
		this.userSubscription = this._userService.user$.subscribe((data) => {
			this.user = data;
		});
		this.parcelDetail = this.data.parcelDetail;
		if (this.data.parcelDetail.attachments)
		{
			this.regularAttachments = this.data.parcelDetail.attachments.filter((a) => a.fileCategory !== 'POD_IMAGE');
			this.podAttachments = this.data.parcelDetail.attachments.filter((a) => a.fileCategory === 'POD_IMAGE');
		}
		this.id = this.data.id;
		this.dateTimeFormat = this._dateTimeService.getDateTime();
	}


	email() {
		const dialogRef = this._modalService.displayEmailParcelDetailsModal(this.id,'name', 'DETAILED');
		dialogRef.afterClosed().subscribe((result) => {
			if (result) {
				this._snackbarService.openSnackBar('Email Sent', 'Close', 5000, 'success');
			}
		}, (error) => {
			this._errorService.error(error, 'Emailing shipping label failed', 'modal');
		});
	}
	
	print() {
		this._spinnerService.startSpinner();
		this.trackParcelService.generateParcelDetails(this.id).subscribe((response: any) => {
				const file = new Blob([response], {type: 'application/pdf'});
				if ((window.navigator as any).msSaveOrOpenBlob) { // IE and Edge functionality
					(window.navigator as any).msSaveOrOpenBlob(file, 'Shipping Label-' + this.data.id + '.pdf');
				} else {
					this._fileService.openFileNewWindow(file);
				}
				this._spinnerService.stopSpinner();
			},
			(error) => {
				this._spinnerService.stopSpinner();
				if (error.error instanceof Blob) {
					const file = new Blob([error.error], {type: error.error.type});
					const fr = new FileReader();
					fr.onload = (e: any) => {
						if (error.error.type === 'application/json') {
							error = JSON.parse(e.target.result);
						}
						this._errorService.error(error, 'generateParcelDetails Failed', 'modal');
					};
					fr.readAsText(file);
				} else {
					this._errorService.error(error, 'generateParcelDetails Failed', 'modal');
				}
			});	
	}
}
